<template>
  <Form mode="edit"/>
</template>

<script>
import Form from './Form/Form'
export default {
  name: "Edit",
  components: { Form }
}
</script>

<style>

</style>